<span
  class="visible-xs menu-glyphicon"
  [ngClass]="{
    'toggle-icon': showMenubar
  }"
>
  <span
    aria-hidden="true"
    (click)="onOpenCloseMenuClick()"
    role="button"
    aria-label="close"
  >
    <fa-icon class="glyphicon-menu-hamburger" [icon]="faBars"></fa-icon>
  </span>
</span>

<nav
  class="col-md-1 col-lg-1 col-sm-1 col-1 leftnav animation-navbar hide-for-small-menu"
  role="navigation"
  [ngClass]="{
    'show-for-small-menu': showMenubar,
    'hide-for-small-menu': !showMenubar
  }"
  click-outside
  (onClickOutside)="collapseAll()"
  *ngIf="(userRoleDetails.roleAssigned == noRoleAssignStatus.RolesAssigned || userRoleDetails.roleAssigned == noRoleAssignStatus.OnlyInvoice) && (showLeftNavigationBar())"
>
  <ul class="main-ul"
    [ngClass]= 
    "{
      'disabled-cur': isMenuDisabled
    }">
    <ng-container
      *ngFor="let menu of menuList; let currentIndex = index"
    >
    <li
      class="navbar-item "
      [ngClass]="{ ' menu-{{ menu.name }} {{ menu.src }}': selectedIndex == currentIndex }"
      *ngIf="menu.isMenuVisible"
      (click)="onMainMenuClicked($event, currentIndex)"
      title="{{ menu.title }}"
  >
    <a
      class="menu-{{ menu.name }} {{ menu.src }}"
      [ngClass]="{ 'menu-selected active': selectedIndex == currentIndex }"
    >
    <span class="menu-label">{{ menu.title }}</span>
      <span
        class="alert-counter1" style="display:inline-block;"
        *ngIf="menu.src == 'menu_alert' && alertCount > 0"
        [ngStyle]="{
          'top': reservationCount > 0 &&
          isOrderStubEnabled ? '-38px' : '-53px'
        }"
        [matBadge]="alertCount"
        matBadgeSize="medium"
        matBadgeColor="warn"
      >
      </span>
      <!--
          *ngFor="let menu of menuList; let currentIndex = index"





        <div
        class="hl7-sqaure-top"
        *ngIf="menu.src == 'menu_alert' && alertCount > 0"
      >
        <div class="hl7-count-txt" id="alert_counter2">
          {{ alertCount  }}
        </div>
      </div> -->
      <div
        class="hl7-sqaure-top2"
        *ngIf="
          menu.src == 'menu_alert' &&
          reservationCount > 0 &&
          isOrderStubEnabled
        "
      >
        <div class="hl7-count-txt" id="alert_counter2">
          {{ reservationCount }}
        </div>
      </div>
      <!-- <div class="hl7-sqaure" *ngIf="
          menu.src == 'menu_alert' && hl7alertCount > 0 && alertCount > 0
        ">
        <div class="hl7-count-txt" id="alert_counter2">
          {{ hl7alertCount }}
        </div>
      </div> -->
    </a>

    <ul
      [hidden]="!menu.config.showSubMenu"
      class="nav-ul"
    >
      <li
        class="navbar-submenu-item"
        *ngFor="let subItem of menu.subItems; let currentIndex = index"
        title="{{ subItem.title }}"
      >
        <div>
          <a
            [hidden]="!subItem.hasSubMenuItems"
            (click)="onSubItemClicked(subItem)"
          >
            <span [hidden]="subItem.showSubMenuItems">+</span>
            <span [hidden]="!subItem.showSubMenuItems">-</span>
            {{ subItem.title }}
          </a>
          <a
            [hidden]="subItem.hasSubMenuItems"
            (click)="onSubItemClicked(subItem)"
          >
            {{ subItem.title }}
            <span
              class="sub-alert-counter1"
              style="right: -20px"
              [ngClass]="{ 'low-alert': !isHighAlert }"
              *ngIf="subItem.name == 'alerts' && alertCount > 0"
              [matBadge]="alertCount"
              matBadgeSize="medium"
              matBadgeColor="warn"
            ></span>
            <!-- <div class="sub-hl7-alert-counter1" *ngIf="
            subItem.name == 'alerts' &&  alertCount > 0
            ">
              <div class="hl7-count-txt" id="alert_counter1">
                {{ alertCount }}
              </div>
            </div> -->
            <!-- <div class="sub-hl7-alert-counter1" *ngIf="
                subItem.name == 'hl7-alerts-messages' && hl7alertCount > 0
              ">
              <div class="hl7-count-txt" id="alert_counter2">
                {{ hl7alertCount }}
              </div>
            </div> -->
            <div
              class="sub-hl7-alert-counter1"
              *ngIf="
                subItem.name == 'reservation' &&
                reservationCount > 0 &&
                isOrderStubEnabled
              "
            >
              <div class="hl7-count-txt" id="alert_counter2">
                {{ reservationCount }}
              </div>
            </div>
          </a>
        </div>

        <div class="submenu" [hidden]="!subItem.showSubMenuItems">
          <div
            class="nowrap"
            *ngFor="let subMenuItem of subItem.subMenuItems"
          >
            <a
              (click)="onSubMenuItemClicked(subMenuItem)"
              style="padding: 0px"
            >
              {{ subMenuItem.title }}
            </a>
          </div>
        </div>
      </li>
    </ul>
    <!-- <div class="menu-label">{{menu.title}}</div> -->
  </li>

    </ng-container>

  </ul>
</nav>
